import { useCallback, useEffect, useState } from "react";
import { Users } from "lucide-react";
import { api } from "@/lib/api";
import { AddToPlan } from "@/components/AddToPlan";

const STATUS = { live: "Already live", built: "Built, not live", "in town list": "In your town list", new: "New idea", planned: "In build plan" };

export const SubscriberInsights = () => {
  const [d, setD] = useState(null);
  const [countries, setCountries] = useState(["Italy"]);
  const load = useCallback(() => api.get("/subscribers/insights").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { load(); api.get("/countries").then((r) => setCountries(r.data.map((c) => c.name))).catch(() => {}); }, [load]);
  if (!d) return null;
  const top = d.towns.filter((t) => t.watched + t.compared > 0).slice(0, 10);
  const max = Math.max(1, ...top.map((t) => t.watched + t.compared));
  return (
    <section className="border border-[#E2D9CC] bg-white p-6 space-y-5" data-testid="subscriber-insights">
      <p className="eyebrow flex items-center gap-2"><Users className="w-4 h-4" />Subscriber insights · {d.subscribers} active</p>
      <div>
        <p className="text-sm text-[#3B1B48] mb-2">Most watched and compared towns</p>
        {top.length === 0 ? <p className="text-sm text-[#8C827A]" data-testid="insights-empty">No watches or comparisons yet. They'll appear as people sign up on the calculators page.</p> : (
          <ul className="space-y-2">{top.map((t) => (
            <li key={t.town} data-testid={`insights-town-${t.town.toLowerCase().replace(/\W+/g, "-")}`} className="text-sm">
              <div className="flex justify-between"><span>{t.town} <span className="text-[#8C827A] text-xs">{t.region}</span></span><span className="text-[#6B5B4E] text-xs">{t.watched} watching · {t.compared} compared</span></div>
              <div className="h-1.5 bg-[#F4EFE6] mt-1"><div className="h-full bg-[#C59B27]" style={{ width: `${((t.watched + t.compared) / max) * 100}%` }} /></div>
            </li>))}</ul>)}
      </div>
      <div className="border-t border-[#E2D9CC] pt-4">
        <p className="text-sm text-[#3B1B48] mb-2">Requested towns</p>
        {d.requests.length === 0 ? <p className="text-sm text-[#8C827A]" data-testid="insights-requests-empty">No requests yet.</p> : (
          <ul className="divide-y divide-[#E2D9CC]">{d.requests.slice(0, 15).map((r) => (
            <li key={r.town} className="flex flex-wrap items-center gap-2 py-2 text-sm" data-testid={`insights-request-${r.town.toLowerCase().replace(/\W+/g, "-")}`}>
              <span className="mr-auto">{r.town} <span className={`ml-2 text-[10px] uppercase tracking-wider ${r.status === "new" ? "text-[#A4462A]" : "text-[#8C827A]"}`}>{STATUS[r.status]}</span>
                <span className="ml-2 text-[#6B5B4E] text-xs">{r.count} request{r.count === 1 ? "" : "s"}</span></span>
              <AddToPlan r={r} countries={countries} onAdded={load} />
            </li>))}</ul>)}
      </div>
    </section>
  );
};
